import { Box, createStyles, List, ListItem, makeStyles, Theme, Typography } from '@agentnet/components';
import clsx from 'clsx';
import { HELP_ROUTE } from 'features/help/constants';
import React, { ReactElement, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TopicCollection } from '../../../types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navItems: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      '& a': {
        textDecoration: 'none',
      },
    },
    menuItem: {
      padding: theme.spacing(1, 0),
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    fw500: {
      fontWeight: 500,
    },
  }),
);

function LeftHandNav({ topics }: { topics?: TopicCollection | null }): ReactElement | null {
  const classes = useStyles();
  const location = useLocation();

  const pathParts = useMemo(() => location.pathname.split('/'), [location.pathname]);
  const isSelected = (slug: string, length: number) => {
    if (pathParts.length > length) {
      return false;
    }

    return pathParts.includes(slug);
  };

  return (
    <div data-testid="kb-left-hand-nav" className="kb-l3">
      <Box mb={2}>
        <Typography color="textPrimary" variant="h4" data-testid="kb-left-hand-nav-header">
          Browse by Topic
        </Typography>
      </Box>

      <div className={classes.navItems} data-testid="kb-left-hand-nav-items">
        {topics?.ansKbTopicCollection?.items?.map((topic, index) => {
          return (
            <div key={`${topic.topicName}-l3-topic-${index}`}>
              <List component="nav" aria-labelledby="nested-list-subheader" disablePadding>
                <Link to={`${HELP_ROUTE}/${topic.slug}`}>
                  <ListItem button className={clsx(classes.menuItem)}>
                    <Typography
                      className={clsx(classes.fw500)}
                      color={isSelected(topic.slug, 4) ? 'primary' : 'textPrimary'}
                      variant="body2"
                    >
                      {topic.topicName}
                    </Typography>
                  </ListItem>
                </Link>
              </List>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export { LeftHandNav };
